import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';

@Injectable()
export class MediaProvider {
  apiBase = baseUrlFunc() + "wp/v2/media"
  fileTransfer: FileTransferObject

  constructor(public http: HttpInterceptorProvider, private transfer: FileTransfer) {
    this.fileTransfer = this.transfer.create();
  }

  sendMediaByFile(filePath: string): Observable<any> {
    return Observable.create(observer => {
      this.getFileFromStorage(filePath).subscribe(file => {

        let header = new HttpHeaders({
     //     "Content-Disposition": 'form-data; name="file"',
          "Authorization": "Basic YWRtaW46aXRsZWFuMjAxOA==",
        })
        var formData = new FormData();
        formData.append("file", file, file["name"]);

        let options = {
          headers: header
        }

        this.http.postFile(this.apiBase, formData, options).subscribe(success => {
          console.log('postFile', success);

          var baselink = baseUrlFunc()
          var baselinkPieces = baselink.split("/wp-json")

          observer.next(success.source_url)
        }, error => {
          console.log('postFile error', error);
          observer.error(error)
        })

      })

    })
  }

  sendMediaByFileObj(file: File): Observable<any> {
    return Observable.create(observer => {

      let header = new HttpHeaders({
        "Authorization": "Basic YWRtaW46aXRsZWFuMjAxOA==",
      })
      var formData = new FormData();
      formData.append("file", file, file["name"]);

      let options = {
        headers: header
      }

      this.http.postFile(this.apiBase, formData, options).subscribe(success => {
        console.log('postFile', success);

        var baselink = baseUrlFunc()
        var baselinkPieces = baselink.split("/wp-json")

        observer.next(success.source_url)
      }, error => {
        console.log('postFile error', error);
        observer.error(error)
      })

    })

  }


  getFileFromStorage(filePath: string): Observable<Blob> {
    return Observable.create(subscribe => {
      (<any>window).resolveLocalFileSystemURL(filePath, function (fileEntry) {
        console.log('resolveLocalFileSystemURL: ', fileEntry.fullPath);

        fileEntry.file(file => {
          console.log('resolveLocalFileSystemURL fileEntry.file: ', fileEntry.fullPath);

          var fr = new FileReader()
          fr.onloadend = function (data) {

            const imgBlob = new Blob([this.result], { type: file.type });
            imgBlob["name"] = file.name

            console.log('resolveLocalFileSystemURL onloadend', imgBlob);
            subscribe.next(imgBlob)
          }

          fr.readAsArrayBuffer(file)

        }, fail => {
          console.log('resolveLocalFileSystemURL fileEntry.file fail: ', fail);
        })
      });
    })
  }


  getFileAsBlobBuffer(file: File): Observable<Blob> {
    return Observable.create(subscribe => {
      var fr = new FileReader()
      fr.onloadend = function (data) {

        const imgBlob = new Blob([this.result], { type: file.type });
        imgBlob["name"] = file.name

        console.log('resolveLocalFileSystemURL onloadend', imgBlob);
        subscribe.next(imgBlob)
      }

      fr.readAsArrayBuffer(file)

    })
  }
}
//rest_upload_unknown_error


// WEBPACK FOOTER //
// ./src/providers/media/media.ts